export default {"src":"/_next/static/image/public/images/ic_blue_syncnow.8d6af9b02522edb8d7b7b7f6bf27deda.svg","height":24,"width":24};